import {
  CopilotConfiguration,
  CopilotToken,
  CopilotTokenGeneratePayload,
  CopilotTokenRefreshPayload,
} from 'interfaces/copilot';

import { api } from './api';

/**
 * Fetches the configuration for Copilot.
 *
 * @returns A promise that resolves to the Copilot configuration or null if not available.
 */
export function getCopilotConfiguration() {
  return api.get<CopilotConfiguration | null>(`/copilot/configuration`);
}

/**
 * Generates a new Copilot token.
 *
 * @returns A promise that resolves to the generated Copilot token.
 */
export function generateCopilotToken(payload: CopilotTokenGeneratePayload = {}) {
  return api.post<CopilotToken>(`/copilot/token/generate`, payload);
}

/**
 * Refreshes an existing Copilot token.
 *
 * @param payload The payload containing the token to refresh.
 * @returns A promise that resolves to the refreshed Copilot token.
 */
export function refreshCopilotToken(payload: CopilotTokenRefreshPayload) {
  return api.post<CopilotToken>(`/copilot/token/refresh`, payload);
}
